export default "__VITE_ASSET__AS28RFTF__"